/* actions-ui.js — Atelier de correction : une ligne par correction, case
 * « Appliquer », correction dans la page quand c'est possible, commande unique
 * sinon. Les choix survivent à un changement de profil. Expose window.ActionsUI. */
(function () {
  'use strict';

  var A = window.MediaActions;
  var F = window.MediaFormat;
  var L = A.LABELS;
  var LS_ENV = 'meta-lab.shell';

  // patch.js pour la famille MP4, mkv-patch.js pour les Matroska.
  function patcher() {
    var raw = ctx.model && ctx.model.container && ctx.model.container.formatRaw;
    if (!raw) return null;
    if (window.MediaPatch && window.MediaPatch.CONTAINERS[raw]) return window.MediaPatch;
    if (window.MediaMkvPatch && window.MediaMkvPatch.CONTAINERS[raw]) return window.MediaMkvPatch;
    return null;
  }
  var ctx = { gaps: [], model: null, fileName: '', fixes: [], file: null };
  var scanned = null;   // repérage des octets corrigeables du fichier ouvert
  var scanFile = null;  // fichier déjà repéré
  var madeName = null;  // dernier fichier corrigé fabriqué ici
  var env = loadEnv();
  var copy = false;
  var memory = {};   // paramètres choisis, par correction
  var skipped = {};  // corrections décochées
  var memoryFile = null;
  var bound = null; // conteneur des écarts et des corrections, pour les rafraîchissements

  function loadEnv() {
    try { var v = localStorage.getItem(LS_ENV); if (A.ENVIRONMENTS[v]) return v; } catch (_) {}
    return A.detectEnvironment(navigator);
  }
  function saveEnv() { try { localStorage.setItem(LS_ENV, env); } catch (_) {} }

  /* Une correction proposée par deux écarts forme une seule ligne, qui règle
   * les deux. `items` : vue des écarts par index. */
  function prepare(gaps, model, fileName, items, file) {
    if (memoryFile !== fileName) { memory = {}; skipped = {}; copy = false; memoryFile = fileName; madeName = null; }
    ctx = { gaps: gaps, model: model, fileName: fileName || 'fichier', fixes: [], file: file || null };
    var byKey = {};
    var byIndex = {};
    (items || []).forEach(function (it) { byIndex[it.index] = it; });
    gaps.forEach(function (g, gi) {
      (g.actions || []).forEach(function (a) {
        var k = A.actionKey(a);
        var m = memory[k];
        if (m) Object.keys(m).forEach(function (p) { a.params[p] = m[p]; });
        var gapItem = byIndex[gi];
        if (!byKey[k]) { byKey[k] = { key: k, actions: [], gaps: [] }; ctx.fixes.push(byKey[k]); }
        byKey[k].actions.push(a);
        if (gapItem && byKey[k].gaps.indexOf(gapItem) < 0) byKey[k].gaps.push(gapItem);
      });
    });
    // sans perte d'abord, comme dans la commande
    ctx.fixes.sort(function (x, y) { return A.NATURE_ORDER.indexOf(x.actions[0].nature) - A.NATURE_ORDER.indexOf(y.actions[0].nature); });
  }

  function fixOf(key) { for (var i = 0; i < ctx.fixes.length; i++) if (ctx.fixes[i].key === key) return ctx.fixes[i]; return null; }
  function selected() { return ctx.fixes.filter(function (f) { return !skipped[f.key]; }); }
  function selectedActions() { return selected().map(function (f) { return f.actions[0]; }); }
  function fixKeyOfGap(gi) {
    var g = ctx.gaps[gi];
    return g && g.actions && g.actions.length ? A.actionKey(g.actions[0]) : null;
  }

  /* ---------- Rendu ---------- */
  function paramHtml(f) {
    var a = f.actions[0];
    var id = 'fix-' + f.key.replace(/[^a-z0-9]/gi, '_');
    var attrs = ' id="' + id + '" data-fix="' + F.esc(f.key) + '"';
    var sel;
    if (a.type === 'set-language') {
      sel = '<select' + attrs + ' data-param="language"><option value="">' + F.esc(L.toChoose) + '…</option>' + A.LANGUAGES.map(function (l) {
        return '<option value="' + l.code + '"' + (a.params.language === l.code ? ' selected' : '') + '>' + F.esc(l.label) + ' (' + l.code + ')</option>';
      }).join('') + '</select>';
      return '<label class="fix-param" for="' + id + '">' + F.esc(L.language) + ' ' + sel + '</label>';
    }
    if (a.type === 'single-default') {
      sel = '<select' + attrs + ' data-param="keep">' + a.params.tracks.map(function (n) {
        return '<option value="' + n + '"' + (a.params.keep === n ? ' selected' : '') + '>Audio ' + n + '</option>';
      }).join('') + '</select>';
      return '<label class="fix-param" for="' + id + '">' + F.esc(L.keepDefault) + ' ' + sel + '</label>';
    }
    if (a.type === 'change-container') {
      sel = '<select' + attrs + ' data-param="container">' + Object.keys(A.CONTAINERS).map(function (c) {
        return '<option value="' + F.esc(c) + '"' + (a.params.container === c ? ' selected' : '') + '>' + F.esc(A.CONTAINERS[c].label) + '</option>';
      }).join('') + '</select>';
      return '<label class="fix-param" for="' + id + '">' + F.esc(L.container) + ' ' + sel + '</label>';
    }
    return '';
  }

  function baText(f) {
    var a = f.actions[0];
    return a.nature === 'metadata' && A.ready(a) ? A.beforeAfter(a, ctx.model).join(' ; ') : '';
  }

  function fixHtml(f) {
    var a = f.actions[0];
    var on = !skipped[f.key];
    var ready = A.ready(a);
    var why = f.gaps.map(function (g) {
      return '<button type="button" class="linkbtn" data-goto-gap="' + g.index + '">' + F.esc(g.title) + '</button>' +
        (g.subject ? ' <span class="fix-subj">' + F.esc(g.subject) + '</span>' : '');
    }).join(' ; ');
    var warn = A.warningsOf(a, ctx.model).map(function (w) { return '<li>' + F.esc(A.WARNINGS[w]) + '</li>'; }).join('');
    var ba = baText(f);
    return '<li class="fix' + (on ? '' : ' off') + (on && !ready ? ' pending' : '') + '" id="fix-' + F.esc(f.key.replace(/[^a-z0-9]/gi, '_')) + '-item" data-fix-item="' + F.esc(f.key) + '">' +
      '<label class="fix-check"><input type="checkbox" data-include="' + F.esc(f.key) + '"' + (on ? ' checked' : '') + '>' +
      '<span class="sr-only">' + F.esc(L.include) + '</span></label>' +
      '<div class="fix-body">' +
        '<p class="fix-title">' + F.esc(A.title(a)) + ' <span class="cmd-nature ' + a.nature + '">' + F.esc(A.natureLabel(a.nature)) + '</span></p>' +
        '<p class="fix-what">' + F.esc(A.explain(a)) + '</p>' +
        (why ? '<p class="fix-why"><span class="fix-k">' + F.esc(L.resolves) + '</span> ' + why + '</p>' : '') +
        paramHtml(f) +
        '<p class="fix-ba" data-ba="' + F.esc(f.key) + '"' + (ba ? '' : ' hidden') + '><span class="fix-k">' + F.esc(L.beforeAfter) + '</span> ' + F.esc(ba) + '</p>' +
        (warn ? '<ul class="cmd-warnings">' + warn + '</ul>' : '') +
      '</div></li>';
  }

  function envHtml() {
    return '<label class="cmd-env">' + F.esc(L.environment) + ' <select data-env>' +
      Object.keys(A.ENVIRONMENTS).map(function (k) {
        return '<option value="' + k + '"' + (k === env ? ' selected' : '') + '>' + F.esc(A.ENVIRONMENTS[k]) + '</option>';
      }).join('') + '</select></label>';
  }

  /* ---------- Correction dans ce navigateur ---------- */

  // Une fois par fichier.
  function ensureScan(root) {
    var P = patcher();
    if (!P || !ctx.file || scanFile === ctx.file) return;
    scanFile = ctx.file;
    scanned = null;
    var file = ctx.file;
    var read = function (offset, length) {
      return file.slice(offset, offset + length).arrayBuffer().then(function (b) { return new Uint8Array(b); });
    };
    P.scan(read, file.size, ctx.model.container.formatRaw).then(function (res) {
      if (scanFile !== file) return;
      scanned = res;
      refresh(root);
    }, function () { scanned = { ok: false, reason: P.REASONS.unreadable || P.REASONS.noMoov }; refresh(root); });
  }

  // Cochées et applicables ici même.
  function browserPlan() {
    var P = patcher();
    if (!P || !scanned || !scanned.ok) return null;
    var acts = selectedActions().filter(function (a) { return P.supports(a) && A.ready(a); });
    if (!acts.length) return null;
    var res = P.plan(acts, scanned);
    return res.patches.length ? res : null;
  }

  // Cochées et applicables par recopie des paquets.
  function copyPlan() {
    if (!ctx.file) return null;
    var acts = selectedActions().filter(function (a) { return A.copyHandles(a) && A.ready(a); });
    if (!acts.length) return null;
    var p = A.copyPlan(acts, ctx.model);
    return p.actions.length ? p : null;
  }

  function browserHtml() {
    var P = patcher();
    if (!P || !ctx.file) return '';
    var total = selectedActions().length;
    if (scanned && !scanned.ok) {
      return selectedActions().some(P.supports)
        ? '<p class="cmd-note">' + F.esc(A.fill(L.notInBrowser, { reason: scanned.reason })) + '</p>' : '';
    }
    var plan = browserPlan();
    var copy = copyPlan();
    if (!plan && !copy) return '';
    var n = (plan ? plan.changes.length : 0) + (copy ? copy.actions.length : 0);
    var lines = [];
    if (plan) lines.push('<p class="fix-ba"><span class="fix-k">' + F.esc(L.beforeAfter) + '</span> ' +
      F.esc(plan.changes.map(function (c) {
        return (c.label ? c.label + ' : ' : '') + (c.before || L.none) + ' → ' + c.after;
      }).join(' ; ')) + '</p>');
    if (copy) lines.push('<p class="fix-ba"><span class="fix-k">' + F.esc(L.copyStep) + '</span> ' +
      F.esc(A.fill(L.copyExplain, { format: copy.label })) + '</p>');
    return '<div class="in-browser"><h5>' + F.esc(L.inBrowser) + '</h5>' +
      '<p class="fix-what">' + F.esc(copy ? L.copyNote : L.inBrowserNote) + '</p>' +
      lines.join('') +
      '<p class="cmd-note">' + F.esc(n === total ? A.fill(L.coveredAll, { total: total }) : A.fill(L.covered, { n: n, total: total })) +
      (n < total ? ' ' + F.esc(L.restCommand) : '') + '</p>' +
      (progressHtml()) +
      '<div class="fix-run"><button type="button" class="act" data-make>' + F.esc(L.makeFile) + '</button>' +
      (madeName ? '<span class="made">' + F.esc(A.fill(L.made, { name: madeName })) + '</span>' +
        '<button type="button" class="act tiny secondary" data-analyze-made>' + F.esc(L.analyzeFixed) + '</button>' : '') + '</div></div>';
  }

  var made = null;      // fichier corrigé fabriqué, prêt à être réanalysé
  var progress = null;  // fraction pendant une recopie

  function progressHtml() {
    return progress == null ? ''
      : '<p class="cmd-note"><progress value="' + Math.round(progress * 100) + '" max="100"></progress> ' +
        Math.round(progress * 100) + ' %</p>';
  }

  /* Recopie des paquets d'abord si le conteneur change, retouches d'octets
   * ensuite — sur le fichier produit, pas sur l'original. */
  async function makeFile(btn) {
    var file = ctx.file;
    if (!file) return;
    var copy = copyPlan();
    var name = A.outputName(ctx.fileName, copy ? copy.ext : null, '-corrige');
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = L.making;
    var root = btn.closest('#panelMain') || document;
    try {
      var blob = file;
      if (copy) {
        progress = 0; refresh(root);
        var CV = (await import('./core/convert.js')).default;
        var res = await CV.run(file, copy, { onProgress: function (p) { progress = p; refresh(root); } });
        progress = null;
        if (!res.ok) {
          madeName = null;
          alertDiscarded(res);
          btn.disabled = false; btn.textContent = label; refresh(root);
          return;
        }
        blob = new File([res.blob], name, { type: res.blob.type });
      }
      var bytes = await bytePatch(blob, copy ? null : browserPlan());
      if (bytes) blob = bytes;
      save(blob, name);
      madeName = name;
      made = new File([blob], name, { type: blob.type });
    } catch (e) {
      madeName = null;
      window.App && window.App.flash ? window.App.flash(String(e && e.message || e)) : null;
    }
    btn.disabled = false; btn.textContent = label;
    refresh(root);
  }

  // Retouches d'octets, sans rien déplacer.
  async function bytePatch(blob, known) {
    var plan = known;
    var P = patcher();
    if (!P) return null;
    if (!plan) {
      var acts = selectedActions().filter(function (a) { return P.supports(a) && A.ready(a); });
      if (!acts.length) return null;
      var read = function (offset, length) {
        return blob.slice(offset, offset + length).arrayBuffer().then(function (b) { return new Uint8Array(b); });
      };
      var sc = await P.scan(read, blob.size, ctx.model.container.formatRaw);
      if (!sc.ok) return null;
      plan = P.plan(acts, sc);
    }
    if (!plan || !plan.patches.length) return null;
    return new Blob(P.parts(plan.patches, blob.size).map(function (part) {
      return part.bytes ? part.bytes : blob.slice(part.from, part.to);
    }), { type: blob.type || 'application/octet-stream' });
  }

  function alertDiscarded(res) {
    var which = (res.discarded || []).map(function (d) { return (d.kind || 'piste') + (d.codec ? ' ' + d.codec : ''); }).join(', ');
    if (window.App && window.App.flash) window.App.flash(A.fill(L.copyRefused, { tracks: which }));
  }

  // Directement sur le disque si le navigateur le permet.
  function save(blob, name) {
    if (window.showSaveFilePicker) {
      window.showSaveFilePicker({ suggestedName: name }).then(function (handle) {
        return handle.createWritable().then(function (w) { return w.write(blob).then(function () { return w.close(); }); });
      }, function () { download(blob, name); });
      return;
    }
    download(blob, name);
  }

  function download(blob, name) {
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = name;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 60000);
  }

  // Tout ce qui dépend des choix : outils, option copie, commande.
  function outputHtml() {
    var acts = selectedActions();
    var browser = browserHtml();
    var pending = acts.filter(function (a) { return !A.ready(a); }).length;
    var steps = A.plan(acts, { fileName: ctx.fileName, model: ctx.model, copy: copy });
    var html = '';
    if (!acts.length) return '<p class="cmd-note">' + F.esc(L.noneSelected) + '</p>';
    html += browser;
    if (pending) html += '<p class="cmd-warn">' + F.esc(A.LABELS.pending.replace('{count}', pending)) + '</p>';
    if (!steps.length) return html;
    if (browser) html += '<h5 class="cmd-alt">' + F.esc(L.byCommand) + '</h5>';
    var tools = {};
    steps.forEach(function (s) { var t = A.TOOLS[s.tool]; if (t) tools[t.pack] = t; });
    html += '<div class="fix-tools"><span class="fix-k">' + F.esc(L.toolsNeeded) + '</span> ' + Object.keys(tools).map(function (k) {
      var t = tools[k];
      return '<span class="fix-tool"><a href="' + F.esc(t.url) + '" target="_blank" rel="noopener">' + F.esc(t.pack) + '</a> · ' +
        F.esc(L.install) + ' : <code>' + F.esc(t.install[env]) + '</code></span>';
    }).join('') + '</div>';
    if (steps.some(function (s) { return s.tool === 'mkvpropedit'; })) {
      html += '<p class="fix-copy"><label><input type="checkbox" data-copyfile' + (copy ? ' checked' : '') + '> ' + F.esc(L.workOnCopy) + '</label>' +
        '</p>';
    }
    // Une étape par outil ; le bouton copie l'ensemble, dans l'ordre.
    var rendered = A.render(steps, env);
    var text = rendered.map(function (s) { return s.lines.join('\n'); }).join('\n');
    html += rendered.map(function (s, i) {
      var t = A.TOOLS[s.tool];
      return '<div class="cmd-step"><p class="cmd-head"><span class="cmd-nature ' + s.nature + '">' + F.esc(A.natureLabel(s.nature)) + '</span> ' +
        '<span class="mono">' + F.esc(s.tool) + '</span>' + (rendered.length > 1 ? '<span class="cmd-rank">étape ' + (i + 1) + ' sur ' + rendered.length + '</span>' : '') + '</p>' +
        (t && t.why ? '<p class="cmd-why">' + F.esc(t.why) + '</p>' : '') +
        (s.inPlace ? '<p class="cmd-warn">' + F.esc(A.WARNINGS['in-place']) + '</p>' : '') +
        '<pre class="cmd"><code>' + F.esc(s.lines.join('\n')) + '</code></pre></div>';
    }).join('') +
      '<div class="fix-run"><button type="button" class="act" data-copytext="' + F.esc(text) + '">' + F.esc(L.copyAll) + '</button>' +
      '<p class="cmd-note">' + F.esc(L.howTo) + ' ' + F.esc(steps.some(function (s) { return s.inPlace; }) ? L.resultInPlace : L.resultBeside) + '</p></div>';
    return html;
  }

  // Vide si aucun écart n'a de correction.
  function blockBody() {
    if (!ctx.fixes.length) return '';
    return '<p class="block-lede">' + F.esc(L.fixesLede) + '</p>' +
      '<div class="fix-step"><h4 class="step"><span>1</span>' + F.esc(L.step1) + '</h4><ul class="fixes-list">' + ctx.fixes.map(fixHtml).join('') + '</ul></div>' +
      '<div class="fix-step"><h4 class="step"><span>2</span>' + F.esc(L.step2) + '</h4>' + envHtml() + '</div>' +
      '<div class="fix-step"><h4 class="step"><span>3</span>' + F.esc(L.step3) + '</h4><div data-out>' + outputHtml() + '</div></div>';
  }

  function refresh(root) {
    var out = root.querySelector('[data-out]');
    if (out) out.innerHTML = outputHtml();
    ctx.fixes.forEach(function (f) {
      var li = root.querySelector('[data-fix-item="' + cssEsc(f.key) + '"]');
      if (!li) return;
      var on = !skipped[f.key];
      li.classList.toggle('off', !on);
      li.classList.toggle('pending', on && !A.ready(f.actions[0]));
      var ba = li.querySelector('[data-ba]');
      var t = baText(f);
      ba.hidden = !t;
      ba.lastChild.textContent = ' ' + t;
    });
    Array.prototype.forEach.call(root.querySelectorAll('select[data-env]'), function (s) { s.value = env; });
  }
  function cssEsc(s) { return window.CSS && CSS.escape ? CSS.escape(s) : s.replace(/"/g, '\\"'); }

  /* ---------- Événements (délégués) ---------- */
  function bind(root) {
    bound = root;
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-copyfile')) { copy = t.checked; refresh(root); return; }
      if (t.hasAttribute('data-env')) { env = t.value; saveEnv(); refresh(root); return; }
      if (t.hasAttribute('data-include')) {
        var k0 = t.getAttribute('data-include');
        if (t.checked) delete skipped[k0]; else skipped[k0] = true;
        refresh(root); return;
      }
      var p = t.getAttribute('data-param');
      if (!p) return;
      var f = fixOf(t.getAttribute('data-fix'));
      if (!f) return;
      var v = p === 'keep' ? +t.value : (t.value || null);
      memory[f.key] = memory[f.key] || {};
      memory[f.key][p] = v;
      f.actions.forEach(function (a) { a.params[p] = v; });
      refresh(root);
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-make')) { makeFile(b); return; }
      if (b.hasAttribute('data-analyze-made')) { if (made && window.App) window.App.analyze(made); return; }
      if (b.hasAttribute('data-copytext')) copyText(b.getAttribute('data-copytext'), b);
    });
  }

  function copyText(text, btn) {
    var label = btn.textContent;
    function done() { btn.textContent = L.copied; setTimeout(function () { btn.textContent = label; }, 1500); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () {});
  }

  window.ActionsUI = {
    prepare: prepare,
    blockBody: function () { var html = blockBody(); if (bound) ensureScan(bound); return html; }, bind: bind, fixKeyOfGap: fixKeyOfGap,
    count: function () { return ctx.fixes.length; },
    anchorOf: function (key) { return 'fix-' + key.replace(/[^a-z0-9]/gi, '_') + '-item'; },
    env: function () { return env; }, copyText: copyText
  };
})();
